import { HeaderActions } from '@openx/components-header/HeaderActions/HeaderActions';
import { PageHeader } from '@openx/components-header/PageHeader';
import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import type { GetAudiencesListQuery } from '../../graphql/query/audiences/GetAudiencesList.generated';
import { AudienceList } from './AudiencesList/AudienceList';
import { AudienceBulkOperations } from './AudiencesList/components/AudienceBulkOperations';

export const AudiencesPage = () => {
  const { t } = useTranslation();
  const [selectedAudiences, setSelectedAudiences] = useState<GetAudiencesListQuery['audience']>([]);

  const renderActions = useCallback(
    () => (
      <HeaderActions
        actions={[
          {
            color: 'primary',
            href: 'create',
            label: t('Create New Audience'),
            showAsActionButton: true,
          },
        ]}
      />
    ),
    [t]
  );

  const bulkOperationRender = useCallback(
    () => (
      <AudienceBulkOperations selectedAudiences={selectedAudiences} closeAndUnselect={() => setSelectedAudiences([])} />
    ),
    [selectedAudiences]
  );

  return (
    <PageHeader
      render={renderActions}
      titlePrefix="OpenXSelect"
      title={t('Audiences List')}
      emptyMode={!!selectedAudiences.length}
      emptyModeRender={bulkOperationRender}
      sticky
    >
      <AudienceList selectedAudiences={selectedAudiences} setSelectedAudiences={setSelectedAudiences} />
    </PageHeader>
  );
};
